module.exports = __webpack_public_path__ + "static/media/worker.1d033ccf.svg";